module.exports = __webpack_public_path__ + "media/assets/images/navbar_icon_face-a27d4642e4299118e53b056a60affda0.png";